import { type Location, type OpeningHour } from '@a1/shared';
import Chip from '@mui/material/Chip';
import { default as Grid } from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
// @ts-expect-error js utility
import { useGetEntityName } from 'utils/entities';

interface LocationUnavailableContentProps {
  location: Location;
  date: string;
  openingHours: Pick<OpeningHour, 'opens' | 'closes'>[];
}

const LocationUnavailableContent = ({ location, date, openingHours }: LocationUnavailableContentProps) => {
  const bookingEntityName = useGetEntityName('booking');

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Typography variant="h4">{bookingEntityName} is outside of this location&apos;s typical opening hours.</Typography>
      </Grid>

      <Grid size={12}>
        <Typography color="primary" fontWeight="bold">
          Location
        </Typography>
        <Chip label={location.name} size="small" />
      </Grid>

      <Grid size={12}>
        <Typography color="primary" fontWeight="bold">
          {dayjs(date).format('dddd')}:
        </Typography>
        {openingHours.length > 0 ? (
          <>
            <ul style={{ margin: 0 }}>
              {openingHours.map((openingHour, index) => (
                <li key={`opening-hour-${index}`}>
                  <Typography>
                    {openingHour.opens} - {openingHour.closes}
                  </Typography>
                </li>
              ))}
            </ul>
          </>
        ) : (
          <Typography>No available times.</Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default LocationUnavailableContent;
